export default {
    namespaced: true,

    state: {
        userList: []
    },

    mutations: {
        SET_USER_LIST(state, list) {
            state.userList = list
        },

        ADD_USER(state, user) {
            state.userList.push(user)
        }
    },

    actions: {
        setUserLists({ commit }, data) {
            commit("SET_USER_LIST", data)
        },

        addUser({ commit }, data) {
            commit("ADD_USER", data)
        }
    },

    getters: {
        getUserList(state) {
            return state.userList
        }
    }
}